<template>
  <div class="content d-flex flex-column justify-content-center bg_cover_login">
    <b-container>
      <b-row>
        <b-col md="4">
          <!-- Login form -->
          <validation-observer
            v-if="type=='login'"
            v-slot="{ handleSubmit }" ref="VForm"
          >
          <b-form
            class="login-form"
            @submit.prevent="handleSubmit(doLogin('/do/login'))"
            novalidate
          >
            <b-card class="mb-0">
              <div class="text-center mb-3">
                <b-img class="mb-1" :src="assetLocal('img/logo-web-colored.png')" width="108" />
                <h5 class="mb-0">Login to your account</h5>
                <span class="d-block text-muted">Your credentials</span>
              </div>
              <b-form-group class="form-group-feedback form-group-feedback-left">
                <b-form-input v-model="input.username" placeholder="Username" />
                <div class="form-control-feedback">
                  <i class="icon-user text-muted"></i>
                </div>
                <VValidate 
                  name="Username" 
                  v-model="input.username" 
                  rules="required"
                />
              </b-form-group>
              <b-form-group class="form-group-feedback form-group-feedback-left">
                  <b-form-input :type="(pwdOpen?'text':'password')" v-model="input.password" placeholder="Password" />
                  
                  <div class="form-control-feedback" @click="pwdOpen=!pwdOpen">
                    <i :class="{'icon-lock2':!pwdOpen, 'icon-unlocked': pwdOpen}"></i>
                  </div>
                  
                  <VValidate 
                    name="Password" 
                    v-model="input.password" 
                    rules="required"
                  />
              </b-form-group>
              <b-form-group class="d-flex align-items-center">
                <b-form-checkbox v-model="input.rememberMe">Remember Me</b-form-checkbox>
              </b-form-group>
              <div class="infoHTML" id="info-login"></div>
              <div class="mb-3">
                <b-button type="submit" variant="primary" block>Log in <i class="icon-circle-right2 ml-2"></i></b-button>
              </div>
              <p class="text-center">Copyright {{Config.app.copyright()}} &copy; {{Config.app.company}}.<br />All Rights Reserved.</p>
            </b-card>
          </b-form>
          </validation-observer>
          <!-- /login form -->
        </b-col >
      </b-row>
    </b-container>
  </div>
</template>

<script>
import GlobalVue from '@/libs/Global'
import $ from 'jquery'

export default {
  extends:GlobalVue,
  data() {
    return {
      type:'login',
      pwdOpen: false,
      loading: false
    }
  },
  methods: {
    doLogin(action){
      this.$refs['VForm'].validate().then(success => {
        if (!success) return
        var infoLogin = $("#info-login")
        infoLogin.attr("class","infoHTML alert alert-info")
        $("#info-login").html("Authenticating and authorizing...")
        this.loading = true
        setTimeout(()=>{
          this.doSubmit(action, this.input, (_, resp)=>{
            this.loading = false
            if (resp.status != 'success') return false

            if (!resp.data.token) return this.type = "2fa"
      
            this.$store.commit('updateUserToken', { token: resp.data.token })
            this.$store.commit('updateUser', { user: resp.data.user })


            if(this.$route.query.continue) {
              return window.location=this.baseUrl+''+this.$route.query.continue
            }
            window.location=this.baseUrl
          })
        },2000)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .login-register {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    height: 100%;
    width: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url("/backoffice/assets/images/login-bg.jpg");
  }
  .login-box {
    width: 400px;
    margin: 0 auto;
  }
</style>